import React, { useEffect, useState } from "react";
import { MenuSelect } from "../components/Form";
import { TbUser } from "react-icons/tb";
import { AiOutlinePoweroff } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import NotificationComp from "../components/NotificationComp";
import { useNavigate } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import { BsBoxArrowLeft } from "react-icons/bs";
import MenuDrawer from "../components/Drawer/MenuDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllNewNotifications,
  getNewNotifications,
} from "../redux/features/notificationSlice";
import {
  getSpecificConfigurationData,
  getSpecificConfigData,
} from "../redux/features/configurationSlice";
import { logoutUser } from "../redux/features/authSlice";
import toast from "react-hot-toast";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [completName, setCompletName] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const newNotifications = useSelector(getAllNewNotifications);
  const specificConfigData = useSelector(getSpecificConfigData);

  // Polling de la campanita (reactivado): consulta /lastnotificaciones al entrar y cada 20s.
  useEffect(() => {
    dispatch(getSpecificConfigurationData());
    dispatch(getNewNotifications());
    const interval = setInterval(() => {
      dispatch(getNewNotifications());
    }, 20000);
    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    if (specificConfigData !== "idle" && specificConfigData?.complet_name) {
      setCompletName(specificConfigData.complet_name);
    }
  }, [specificConfigData]);

  const toggleDrawer = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      toast.success("Sesión cerrada correctamente");
      sessionStorage.clear();
      localStorage.removeItem("persist:root");
      navigate("/login");
    } catch (error) {
      toast.error(error.message || "Error al cerrar sesión");
    }
  };

  return (
    <>
      {/* Modal de confirmación de cierre de sesión */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
            <h2 className="text-lg font-semibold mb-4">Cerrar sesión</h2>
            <p className="text-sm text-gray-700 mb-6">
              ¿Estás seguro que deseas cerrar sesión?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 text-sm"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  setShowLogoutModal(false);
                  handleLogout();
                }}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      )}

      {isOpen && <MenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />}

      <div className="xl:w-5/6 w-full 2xl:max-w-[1640px] bg-dry grid md:grid-cols-2 grid-cols-12 items-center bg-opacity-95 fixed top-0 z-40 xs:px-8 px-2">
        <div className="md:col-span-1 sm:col-span-11 col-span-10 flex gap-4 items-center md:py-0 py-4">
          <button
            onClick={toggleDrawer}
            className="block xl:hidden border text-2xl bg-greyed w-16 md:w-12 h-12 rounded-md flex-colo text-textGray transitions hover:bg-border"
          >
            <BiMenu />
          </button>
        </div>
        <div className="md:col-span-1 sm:col-span-1 col-span-2 items-center justify-end pr-4 md:pr-0">
          <div className="float-right flex gap-4 items-center justify-center">
            <NotificationComp notifications={newNotifications}>
              <div className="relative">
                <MdOutlineNotificationsNone className="text-2xl hover:text-subMain" />
                {newNotifications?.reduce((acc, cur) => acc + !cur.leido, 0) >
                  0 && (
                  <span className="absolute -top-2.5 -right-2.5 font-semibold bg-subMain rounded-full px-1.5 py-0.5 text-xs text-white text-center">
                    {newNotifications?.reduce(
                      (acc, cur) => acc + !cur.leido,
                      0
                    )}
                  </span>
                )}
              </div>
            </NotificationComp>

            <div className="items-center md:flex">
              <button
                onClick={() => setShowLogoutModal(true)}
                className="hover:text-yellow-400 text-black font-bold bg-none rounded-md flex items-center justify-center text-md"
                style={{ width: "20px", height: "20px" }}
                title="Cerrar sesión"
              >
                <BsBoxArrowLeft size={18} />
              </button>
            </div>

            <div className="items-center md:flex hidden">
              <div className="flex gap-4 items-center p-4 rounded-lg">
                <img
                  src="/images/profile.png"
                  alt="user"
                  className="w-12 border border-border object-cover h-12 rounded-full"
                />
                <p className="text-sm text-textGray font-medium">
                  {completName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
